import { Flex, SimpleGrid, SimpleGridProps, Icon, Text } from "@chakra-ui/react";
import { FaCheckCircle } from "react-icons/fa";
import { decodeHtmlEntities } from "../utils/decodeHtmlEntities";
import { YELLOW_COLOR } from "../const";

interface ColouredTickListProps extends SimpleGridProps {
  data: string[];
}

export const ColouredTickList: React.FC<ColouredTickListProps> = ({ data = [], ...props }) => (
  <SimpleGrid columns={{ base: 2, md: 3, lg: 4 }} gap={4} {...props}>
    {data?.map((item, i) => (
      <Flex key={i} gap={2} alignItems="center">
        <Icon as={FaCheckCircle} boxSize="20px" color={YELLOW_COLOR} />
        <Text>{decodeHtmlEntities(item)}</Text>
      </Flex>
    ))}
  </SimpleGrid>
);
